/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Compare_Credits_SponsorInputs */

const en_landing_pricing_compare_credits_sponsor = /** @type {(inputs: Landing_Pricing_Compare_Credits_SponsorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1,000 / month`)
};

const zh_landing_pricing_compare_credits_sponsor = /** @type {(inputs: Landing_Pricing_Compare_Credits_SponsorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`每月 1,000 次`)
};

/**
* | output |
* | --- |
* | "1,000 / month" |
*
* @param {Landing_Pricing_Compare_Credits_SponsorInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_compare_credits_sponsor = /** @type {((inputs?: Landing_Pricing_Compare_Credits_SponsorInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Compare_Credits_SponsorInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_compare_credits_sponsor(inputs)
	return zh_landing_pricing_compare_credits_sponsor(inputs)
});
export { landing_pricing_compare_credits_sponsor as "landing.pricing.compare_credits_sponsor" }